// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".checkbox-label[data-v-645534fe]{padding-top:.05rem;font-size:13.5px}", ""]);
// Exports
module.exports = exports;
